import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { CheckCircleOutlined, CancelOutlined, HourglassEmptyOutlined } from '@mui/icons-material';

export const BgvChip = ({ v }) =>
    v?.toLowerCase() === 'verified' ? (
        <Chip
            icon={<CheckCircleOutlined sx={{ fontSize: '14px !important' }} />}
            label="Verified"
            size="small"
            color="success"
            variant="outlined"
        />
    ) : (
        <Chip
            icon={<CancelOutlined sx={{ fontSize: '14px !important' }} />}
            label="Not Verified"
            size="small"
            color="error"
            variant="outlined"
        />
    );

BgvChip.propTypes = {
    v: PropTypes.string
};

export const TrainingChip = ({ v }) => {
    if (v?.toLowerCase() === 'completed')
        return (
            <Chip
                icon={<CheckCircleOutlined sx={{ fontSize: '14px !important' }} />}
                label="Completed"
                size="small"
                color="success"
                variant="outlined"
            />
        );
    if (v?.toLowerCase() === 'ongoing')
        return (
            <Chip
                icon={<HourglassEmptyOutlined sx={{ fontSize: '14px !important' }} />}
                label="Ongoing"
                size="small"
                color="info"
                variant="outlined"
            />
        );
    return (
        <Chip
            icon={<CancelOutlined sx={{ fontSize: '14px !important' }} />}
            label="Not Started"
            size="small"
            color="error"
            variant="outlined"
        />
    );
};

TrainingChip.propTypes = {
    v: PropTypes.string
};
